import { createSelector } from '@reduxjs/toolkit';

export const selectForm = (state) => state.amendment.form;
export const selectData = (state) => state.amendment.data;
export const selectError = (state) => state.amendment.error;
export const selectLoading = (state) => state.amendment.loading;
export const selectCreating = (state) => state.amendment.creating;

export const selectProductIdByFileId = (fileId) =>
  createSelector([selectData], (data) => {
    return data.find(({ id }) => id === fileId)?.productId;
  });
